/*
ナビ開閉
*/
class HeaderMenuToggle {

  private buttonEl:HTMLElement;
  private menuEl:HTMLElement;

  constructor() {
    
    this.buttonEl = document.getElementById('headerMenuToggle');
    this.menuEl = document.getElementById('headerMenu');
    
    if(this.buttonEl.dataset.open === 'true'){
      this.open();
    } else {
      this.close();
    }

    this.menuEl.style.display = 'block';

    // add event listeners
    this.buttonEl.addEventListener('click', this.onButtonClick.bind(this));
    //this.menuEl.addEventListener('click', this.onButtonClick.bind(this));
  }

  onButtonClick() {
    this.toggle(!this.open);
  }

  toggle(open) {
    // don't do anything if the open state doesn't change
    if (open === this.open) {
      return;
    }

    // update the internal state
    this.open = open;

    // handle DOM updates
    this.buttonEl.dataset.open = `${open}`;
    if (open) {
      this.menuEl.removeAttribute('hidden');
      document.querySelector('.l-header').classList.add('menu-opened');
      
      //メニュー内スクロール位置戻す
      document.querySelector('.l-header .l-header__menu').scrollTop = 0;

    } else {
      this.menuEl.setAttribute('hidden', '');
      document.querySelector('.l-header').classList.remove('menu-opened');
    }
  }

  // Add public open and close methods for convenience
  open() {
    this.toggle(true);
  }

  close() {
    this.toggle(false);
  }
}

export default HeaderMenuToggle;

